import React, { useState } from 'react'
import { Expander, ExpanderContent, InlineButton, Paragraph, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'

const noParaPaddingCss = css`
  & p {
    padding: 0;
  }
`

export default function MeaningDisplay({ meaning }) {
  const [t] = useTranslation()
  const [doesExpand, setDoesExpand] = useState(false)
  const [open, setOpen] = useState(false)
  return (
    <Expander open={open} setOpen={setOpen} ariaControlsId="expander">
      <ExpanderContent collapsedHeight={96} setDoesExpand={setDoesExpand}>
        <div className={noParaPaddingCss}>
          <Paragraph dangerouslySetInnerHTML={{ __html: meaning }} size="sm" />
        </div>
      </ExpanderContent>
      {doesExpand && (
        <>
          <Separator size="xxs" />
          <InlineButton data-testid="name-meaning-more-less" onClick={() => setOpen(!open)} aria-controls="expander">
            {t(open ? 'common-ui:show-less.info.abbr' : 'common-ui:show-more.info.abbr')}
          </InlineButton>
        </>
      )}
    </Expander>
  )
}
